import api, { openApi } from "../../services/api";
import { getBackendUrl } from "../../config";

const useSettings = () => {
  const getAll = async (params) => {
    const { data } = await api.request({
      url: getBackendUrl() + "/settings",
      method: "GET",
      params,
    });
    return data;
  };

  const update = async (data) => {
    const { data: responseData } = await api.request({
      url: getBackendUrl() + `/settings/${data.key}`,
      method: "PUT",
      data,
    });
    console.log(responseData);
    return responseData;
  };

  const get = async (param) => {
    const { data } = await api.request({
      url: getBackendUrl() + `/setting/${param}`,
      method: "GET",
    });
    return data;
  };

  const getPublicSetting = async (key) => {
    const { data } = await openApi.request({
        url: getBackendUrl() + `/public-settings/${key}`,
        method: 'GET'
    });
    return data;
  };

  return {
    getAll,
    update,
    get,
    getPublicSetting,
  };
};

export default useSettings;
